import React from 'react';
import { useTranslation } from 'react-i18next';
import ArrowLeft from '@wix/da-ds/pkg/Icons/24x24/ArrowLeft';
import { BackToClickBiEvent, BiData } from '@wix/da-bi/pkg/events';
import { DuperbrowseItem } from '../../../Duperbrowse/redux/types';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import s from './BackButton.scss';

export interface Props {
  currentDuperbrowseItem?: DuperbrowseItem;
  exitDuperbrowse?: () => void;
}

const BackButton: React.FC<Props> = ({
  currentDuperbrowseItem,
  exitDuperbrowse,
}) => {
  const { t } = useTranslation();
  const onClick = () => {
    yieldToMain(() => {
      exitDuperbrowse && exitDuperbrowse();
    });
  };

  return (
    <IconButton
      className={s['root']}
      onClick={onClick}
      biData={BiData<BackToClickBiEvent>({
        evid: 304,
        link_url: currentDuperbrowseItem?.url,
        itemid: currentDuperbrowseItem?.deviationId,
        typeid: currentDuperbrowseItem?.typeId,
      })}
      size="small"
      aria-label={t('common.back')}
      icon={ArrowLeft}
    />
  );
};
BackButton.displayName = 'BackButton';

export default BackButton;
